// extracted by mini-css-extract-plugin
export default {"root":"SetSuccess_root__i5BwM","title":"SetSuccess_title__gD5UV","content":"SetSuccess_content__TcrOv","actions":"SetSuccess_actions__Z0KX0"};